import "./_bootstrap";

(function (Drupal) {
  Drupal.megaMenu = Drupal.megaMenu || {};
  Drupal.megaMenu.wrapper = document.querySelector(".mega-menu__wrapper");

  Drupal.megaMenu.freezeScreen = function () {
    document.body.style.overflowY = "hidden";
  };

  Drupal.megaMenu.releaseScreen = function () {
    document.body.style.overflowY = "auto";
  };

  Drupal.megaMenu.openMenu = function () {
    Drupal.megaMenu.freezeScreen();
    Drupal.megaMenu.wrapper.classList.add("mega-menu__wrapper--open");
  };

  Drupal.megaMenu.closeMenu = function () {
    Drupal.megaMenu.releaseScreen();
    Drupal.megaMenu.wrapper.classList.remove("mega-menu__wrapper--open");
  };

  Drupal.behaviors.megaMenu = {
    attach(context) {
      const openButton = once("open", ".mega-menu__open", context);
      const closeButton = once("close", ".mega-menu__close", context);
      const global = once("escape", "body", context);

      openButton.forEach(function (item) {
        item.addEventListener("click", Drupal.megaMenu.openMenu);
      });

      closeButton.forEach(function (item) {
        item.addEventListener("click", Drupal.megaMenu.closeMenu);
      });

      global.forEach(function (item) {
        item.addEventListener("keyup", function (e) {
          if (e.key === "Escape") {
            Drupal.megaMenu.closeMenu();
          }
        });
      });
    },
  };

  Drupal.behaviors.logoColor = {
    attach(context) {
      const logo = once("logoColor", ".canamo-branding__logo #logo", context);
      logo.forEach(function () {
        const colorHsl = [
          [231, 100, 11.8],
          [203.6, 100, 37.5],
          [47.2, 100, 63.3],
          [334.4, 82.4, 42.4],
          [61.4, 68.2, 61.8],
          [53.5, 99.2, 49.6],
          [65.8, 71.1, 51.2],
          [296.3, 59.3, 31.8],
          [326.4, 97.3, 43.9],
          [353.7, 73.1, 79.6],
          [148, 100, 31.6],
          [358.3, 84.5, 52],
          [347, 79, 58.8],
          [198.7, 99.1, 45.1],
        ];
        const root = document.documentElement;
        const randomNumber = Math.floor(Math.random() * colorHsl.length);
        const randColor = colorHsl[randomNumber];
        const hue = randColor[0];
        const saturation = randColor[1];
        const lightness = randColor[2];

        // Decide wether we are increasing or decreasing lightness:
        const increase = lightness < 50;
        // Start on 90 to avoid excessive lightening / darkening.
        const availableLightness = 90 - lightness;

        // Divide the available lightness in equal steps, round down.
        // 6 is hardcoded as we know "Cañamo" has 6 letters on it.
        const stepSize = Math.floor(availableLightness / 6);

        // Generate the CSS custom properties:
        for (let index = 0; index < 6; index++) {
          const newLightness = increase
            ? lightness + stepSize * index
            : lightness - stepSize * index;
          const value = `hsl(${hue}deg, ${saturation}%, ${newLightness}%)`;

          if (index === 5) {
            root.style.setProperty("--logo-color--random", value);
          }

          const target = document.querySelector(`.logo-letter--${index + 1}`);
          target.style.setProperty(`--logo-color`, value);
        }
      });
    },
  };
})(Drupal);
